import { TypedRootState } from '../types';

export const selectFlipped = (state: TypedRootState) => state.flipped;
